<template>
  <div>
    <h1>Мои клиенты</h1>
    <white-bg padding="0" class="first_screen_wrap">
      <row class="row">
        <grid-item xs="12" xl="4" class="side" v-if="isVisibleClients">
          <search class="side__search" placeholder="Имя или номер телефона" v-debounce:300ms="(search) => clients.search = search"/>
          <button @click="newClientOpen" class="side__create">Новый клиент</button>
          <div class="side__previews" style="max-height: 70vh; overflow-y: auto; overflow-x: hidden">
            <transition name="fade">
              <div v-if="clients.data">
                <list :clients="clients.data" @click="setActive"/>
                <div class="more" v-if="canLoadMoreClient">
                  <button @click="loadClients(true)">Еще клиенты</button>
                </div>
              </div>
            </transition>
          </div>
        </grid-item>
        <div class="body" v-if="isVisibleClientInfo">
          <white-bg class="client-side">
            <div class="wrap">
              <div :style="{'display': (createModal ? '' : 'none')}" v-if="createModal">
                <create @created="created" @back="clientsVisible = true"/>
              </div>
              <div v-else>
                <info
                  v-if="clients.selected"
                  :client="clients.selected"
                  @updated="updated"
                  @back="clientsVisible = true"
                />
              </div>
            </div>
          </white-bg>
        </div>
      </row>
    </white-bg>
  </div>
</template>

<script>
import WhiteBg from '../../../../components/ui/white-bg';
import Search from '../../../../components/ui/inputs/custom-search';
import Row from '../../../../components/grid/Row';
import GridItem from '../../../../components/grid/GridItem';
import List from './List';
import Info from './Info';
import Create from './Create';

export default {
  name: 'Clients',
  components: {WhiteBg, GridItem, Search, Row, List, Info, Create},
  data() {
    return {
      createModal: false,
      clients: {
        data: null,
        page: 1,
        last_page: 1,
        search: null,
        selected: null,
      },
      clientsVisible: true
    }
  },
  computed: {
    canLoadMoreClient() {
      return this.clients.page !== this.clients.last_page;
    },
    isMobile () {
      return document.documentElement.clientWidth < 1170
    },
    isVisibleClients () {
      if (!this.isMobile) return true
      return this.clientsVisible
    },
    isVisibleClientInfo () {
      if (!this.isMobile) return true
      return !this.clientsVisible
    }
  },
  watch: {
    'clients.search'() {
      this.clients.page = 1;
      this.loadClients();
    }
  },
  mounted() {
    this.loadClients();
  },
  methods: {
    setActive(index) {
      this.createModal = false;
      this.clients.data.map((val, ind) => {
        val.isActive = index === ind;
        if (index === ind) this.clients.selected = val;
        return val;
      });
      this.clientsVisible = false
    },
    setClients(data, more) {
      this.clients.page = data.meta.current_page;
      this.clients.last_page = data.meta.last_page;

      if (more) return data.data.map((val) => {
        val.isActive = false;
        this.clients.data.push(val);
        return val;
      });

      this.clients.data = data.data.map((val, index) => {
        val.isActive = !index;
        if (val.isActive) this.clients.selected = val;
        return val;
      });
    },
    getClientsFilter() {
      return {
        page: this.clients.page,
        search: this.clients.search,
      }
    },
    created(data) {
      this.clients.data.unshift(data);
      this.setActive(0);
    },
    updated(data) {
      this.clients.data.map((val, index) => {
        if (val.id === data.id) {
          this.$set(this.clients.data, index, data);
          this.setActive(index);
        }
        return val;
      });
    },
    loadClients(more) {
      if (more) this.clients.page += 1;
      else this.clients.selected = null;
      this.$api.master.client.list(this.getClientsFilter())
          .then((data) => this.setClients(data, more));
    },
    newClientOpen() {
      this.clientsVisible = false
      this.createModal = true
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  display: none;
}

h3 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #383838;
  left: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.body {
  width: 66.66%;
}

.whiteBg {
  padding: 0;

  &.client-side {
    height: 100%;
    background: rgba(219, 191, 167, 0.3);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    outline: hidden;
    margin-right: 15px;

    .wrap {
      padding: 30px;
    }
  }
}

.input {
  display: flex;
  justify-content: center;
  border-top: 1px solid #E5E5E5;
  padding: 15px 15px 0px 15px;
}

.side {
  border-right: 1px solid #E5E5E5;
  padding: 0 0;

  &__search {
    margin-left: 15px;
    border-bottom: 1px solid #E5E5E5;;
  }

  &__previews {
    height: 70vh;
    margin-left: 15px;
  }

  &__create {
    position: relative;
    margin: 15px 0 15px 20px;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    color: #B9765B;
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 10px;

    &:before {
      content: '';
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background-image: url("../../../../assets/images/icons/plus.svg");
      background-position: center center;
      background-size: contain;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.more {
  margin-top: 10px;
  margin-bottom: 10px;

  button {
    margin: 0 auto;
    display: flex;
    align-items: center;
    border: none;
    background-color: transparent;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #B9765B;

    &:after {
      content: '';
      width: 20px;
      height: 20px;
      margin-left: 5px;
      background-image: url("../../../../assets/images/icons/chevron-down.svg");
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}

@media screen and (max-width: 1170px) {
  h1 {
    display: block;
    padding-top: 0;
    margin-bottom: 15px;
    font-size: 24px;
    line-height: 32px;
    color: #383838;
    margin-top: -10px;
  }
  .first_screen_wrap {
    margin-left: -15px;
    margin-right: -15px;
  }
  .body {
    width: 100%;
    .whiteBg.client-side {
      margin-right: 0;
      padding: 0 !important;
      .wrap {
        padding: 0;
      }
    }
  }
  .card .master button {
    max-width: 100%;
  }
  .first_screen {
    margin-left: -15px;
    margin-right: -15px;
  }
}
</style>
